import { preload } 		from './modules/mod_preload'
import { navigation } 	from './modules/mod_navigation'
import { slider } 		from './modules/mod_slider'
import { counter } 		from './modules/mod_counter'
import { lightbox } 	from './modules/mod_lightbox'
import { rellax } 		from './modules/mod_rellax'
import { bannerMediaImageReveal } from './modules/mod_banner'
import { reveal } 		from './modules/mod_reveal'

window.onload = function () {
	preload()
	navigation()
	lightbox()
	slider()
	rellax()
	counter()
	reveal()
	bannerMediaImageReveal() // Banner ohne Splide (z. B. banner_item); Splide ruft bei mounted/moved selbst auf
}
